"use client";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { Select } from "ui/core/select";

import { getBuyingTop5Options } from "../data/get-buying-top5-options";
import { Top5Index } from "../data/types";
import { useInsiderBuyingTop5 } from "../services/insider-buying-top5";

type Props = {
  symbol: string;
  top5: Top5Index;
};

export const Top5Select = ({ symbol, top5 }: Props) => {
  const { updateQuery } = useUpdateQuery();
  const {
    data: buyingTop5,
    isLoading,
    isError,
  } = useInsiderBuyingTop5({ symbol });
  const options = getBuyingTop5Options(buyingTop5?.dropDown);

  return isLoading || isError || options.length === 0 ? null : (
    <Select
      options={options}
      defaultValue={options[top5]}
      onChange={(e) => {
        updateQuery({ name: "top5", value: e.target.selectedIndex.toString() });
      }}
      className="w-full sm:max-w-xs"
    />
  );
};
